/**
 * Field Test Form - Retours Terrains
 * Modern multi-product picker with image grid
 */
document.addEventListener('DOMContentLoaded', function() {
    var container = document.querySelector('.field-test-container');
    if (!container) return;

    // ========================================
    // PASSWORD STEP (with SHA-256 hash comparison)
    // ========================================
    var storedHash = container.getAttribute('data-password-hash');
    var passStep = document.getElementById('FieldTest-PasswordStep');
    var formStep = document.getElementById('FieldTest-FormStep');
    var passInput = document.getElementById('FieldTestPassword');
    var passBtn = document.getElementById('FieldTestPasswordSubmit');
    var errorMsg = document.querySelector('.field-test-error');

    // SHA-256 hash function
    async function sha256(message) {
        const msgBuffer = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }

    async function checkPass() {
        if (!passInput) return;
        
        var inputValue = passInput.value;
        
        // If storedHash looks like a hash (64 hex chars), compare hashes
        // Otherwise fallback to plain text comparison (for backwards compatibility)
        var isHash = storedHash && /^[a-f0-9]{64}$/i.test(storedHash);
        
        var isValid = false;
        if (isHash) {
            var inputHash = await sha256(inputValue);
            isValid = (inputHash === storedHash.toLowerCase());
        } else {
            // Fallback: plain text comparison (legacy)
            isValid = (inputValue === storedHash);
        }
        
        if (isValid) {
            passStep.style.display = 'none';
            formStep.style.display = 'block';
            initProductPicker();
        } else {
            errorMsg.style.display = 'block';
            passInput.classList.add('error');
            setTimeout(function() {
                passInput.classList.remove('error');
            }, 500);
        }
    }

    if (passBtn) {
        passBtn.addEventListener('click', checkPass);
    }
    if (passInput) {
        passInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                checkPass();
            }
        });
        // Hide error on input
        passInput.addEventListener('input', function() {
            errorMsg.style.display = 'none';
        });
    }

    // ========================================
    // PRODUCT PICKER
    // ========================================
    var products = [];
    var selectedProducts = [];
    var productGrid = document.getElementById('ProductGrid');
    var searchInput = document.getElementById('ProductSearch');
    var selectedContainer = document.getElementById('SelectedProducts');
    var hiddenInput = document.getElementById('FieldTestProduit');
    var productsInitialized = false;

    function initProductPicker() {
        // Set empty state translation
        var translations = window.fieldTestTranslations || {};
        if (selectedContainer) {
            selectedContainer.setAttribute('data-empty-text', translations.no_products_selected || 'Aucun produit sélectionné');
        }
        
        // Check if products are already loaded
        if (window.fieldTestProductsLoaded) {
            products = window.fieldTestProducts || [];
            renderProducts(products);
            setupSearch();
        } else {
            // Show loading state
            if (productGrid) {
                var translations = window.fieldTestTranslations || {};
                productGrid.innerHTML = '<div class="product-picker-empty loading">' + (translations.loading_products || 'Chargement des produits') + '</div>';
            }
            // Wait for products to load
            window.addEventListener('fieldTestProductsReady', function() {
                products = window.fieldTestProducts || [];
                renderProducts(products);
                setupSearch();
            });
        }
    }
    
    function setupSearch() {
        if (searchInput && !productsInitialized) {
            productsInitialized = true;
            searchInput.addEventListener('input', function() {
                var query = this.value.toLowerCase().trim();
                var filtered = products.filter(function(p) {
                    return p.title.toLowerCase().indexOf(query) !== -1;
                });
                renderProducts(filtered);
            });
        }
    }

    function renderProducts(list) {
        if (!productGrid) return;
        
        if (list.length === 0) {
            var translations = window.fieldTestTranslations || {};
            productGrid.innerHTML = '<div class="product-picker-empty">' + (translations.no_products_found || 'Aucun produit trouvé') + '</div>';
            return;
        }

        productGrid.innerHTML = list.map(function(p) {
            var isSelected = selectedProducts.some(function(s) { return s.id === p.id; });
            var imageHtml = p.image 
                ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
                : '<span class="no-image">📦</span>';
            
            return '<div class="product-card' + (isSelected ? ' selected' : '') + '" data-id="' + p.id + '" data-title="' + escapeHtml(p.title) + '">' +
                '<div class="product-card-image">' + imageHtml + '</div>' +
                '<div class="product-card-title">' + escapeHtml(p.title) + '</div>' +
            '</div>';
        }).join('');

        // Add click handlers
        productGrid.querySelectorAll('.product-card').forEach(function(card) {
            card.addEventListener('click', function() {
                toggleProduct(this.dataset.id, this.dataset.title);
            });
        });
    }

    function toggleProduct(id, title) {
        var index = selectedProducts.findIndex(function(p) { return p.id === id; });
        
        if (index === -1) {
            selectedProducts.push({ id: id, title: title });
        } else {
            selectedProducts.splice(index, 1);
        }
        
        updateSelectedUI();
        updateHiddenInput();
        
        // Update card visual
        var card = productGrid.querySelector('[data-id="' + id + '"]');
        if (card) {
            card.classList.toggle('selected', index === -1);
        }
    }

    function updateSelectedUI() {
        if (!selectedContainer) return;
        
        if (selectedProducts.length === 0) {
            selectedContainer.innerHTML = '';
            return;
        }

        selectedContainer.innerHTML = selectedProducts.map(function(p) {
            return '<span class="selected-tag">' +
                escapeHtml(p.title) +
                '<button type="button" data-id="' + p.id + '" aria-label="Retirer">×</button>' +
            '</span>';
        }).join('');

        // Add remove handlers
        selectedContainer.querySelectorAll('button').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                var id = this.dataset.id;
                var product = selectedProducts.find(function(p) { return p.id === id; });
                if (product) {
                    toggleProduct(product.id, product.title);
                }
            });
        });
    }

    function updateHiddenInput() {
        if (!hiddenInput) return;
        // Send product titles joined by comma (backend will resolve to GIDs)
        hiddenInput.value = selectedProducts.map(function(p) { return p.title; }).join(', ');
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }

    // ========================================
    // ACTIVITY AUTOCOMPLETE
    // ========================================
    function initActivityAutocomplete() {
        var input = document.getElementById('FieldTestActivite');
        var listContainer = document.getElementById('ActivitySuggestions');
        var activities = window.fieldTestActivities || [];

        if (!input || !listContainer || activities.length === 0) return;

        function renderSuggestions(matches) {
            if (matches.length === 0) {
                listContainer.style.display = 'none';
                return;
            }

            listContainer.innerHTML = matches.map(function(activity) {
                return '<div class="suggestion-item">' + escapeHtml(activity) + '</div>';
            }).join('');
            
            listContainer.style.display = 'block';

            // Add click handlers
            listContainer.querySelectorAll('.suggestion-item').forEach(function(item) {
                item.addEventListener('mousedown', function(e) {
                    e.preventDefault(); // Prevent blur
                    input.value = this.textContent;
                    listContainer.style.display = 'none';
                    // Trigger input event in case of other listeners
                    input.dispatchEvent(new Event('input'));
                });
            });
        }

        input.addEventListener('input', function() {
            var val = this.value.toLowerCase().trim();
            var matches = [];
            
            if (val.length === 0) {
                matches = activities;
            } else {
                matches = activities.filter(function(a) {
                    return a.toLowerCase().indexOf(val) !== -1;
                });
            }
            renderSuggestions(matches);
        });

        input.addEventListener('focus', function() {
            var val = this.value.toLowerCase().trim();
            var matches = (val.length === 0) ? activities : activities.filter(function(a) {
                return a.toLowerCase().indexOf(val) !== -1;
            });
            renderSuggestions(matches);
        });

        input.addEventListener('blur', function() {
            setTimeout(function() {
                listContainer.style.display = 'none';
            }, 200);
        });
        
        // Hide when clicking outside
        document.addEventListener('click', function(e) {
            if (e.target !== input && e.target !== listContainer && !listContainer.contains(e.target)) {
                listContainer.style.display = 'none';
            }
        });
    }

    initActivityAutocomplete();

    // ========================================
    // FORM SUBMISSION
    // ========================================
    var mainForm = document.getElementById('FieldTestForm');
    var feedbackMsg = document.getElementById('FormFeedback');
    var submitBtn = mainForm ? mainForm.querySelector('button[type="submit"]') : null;

    // Email validation helper
    function isValidEmail(email) {
        // Check for valid email format: xxx@xxx.xxx
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailRegex.test(email);
    }

    if (mainForm) {
        mainForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Validate email before submitting
            var emailInput = document.getElementById('FieldTestEmail');
            var emailValue = emailInput ? emailInput.value.trim() : '';
            
            var translations = window.fieldTestTranslations || {};
            
            if (!isValidEmail(emailValue)) {
                showFeedback(translations.error_email_invalid || 'Adresse email invalide. Vérifiez le format (ex: nom@domaine.com).', 'error');
                if (emailInput) {
                    emailInput.focus();
                    emailInput.classList.add('input-error');
                    setTimeout(function() {
                        emailInput.classList.remove('input-error');
                    }, 3000);
                }
                return;
            }
            
            var APP_SCRIPT_URL = window.ayaqRestock?.endpoint || '';
            if (!APP_SCRIPT_URL) {
                showFeedback(translations.error_server_missing || 'Erreur: Configuration serveur manquante.', 'error');
                return;
            }

            showFeedback(translations.loading_message || 'Envoi en cours...', 'loading');
            if (submitBtn) submitBtn.disabled = true;

            var fd = new FormData(mainForm);
            var params = new URLSearchParams();
            
            params.append('action', 'field_test');
            
            for (var pair of fd.entries()) {
                params.append(pair[0], pair[1]);
            }
            
            params.append('site', window.location.host);
            params.append('locale', window.Shopify?.locale || 'fr');

            var url = APP_SCRIPT_URL + (APP_SCRIPT_URL.indexOf('?') === -1 ? '?' : '&') + params.toString();

            fetch(url, { method: 'GET', cache: 'no-cache' })
                .then(function(res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.json().catch(function() { return { ok: true }; });
                })
                .then(function(data) {
                    if (data.ok === false) {
                        throw new Error(data.error || 'Erreur inconnue');
                    }
                    var translations = window.fieldTestTranslations || {};
                    showFeedback(translations.success_message || 'Merci ! Votre retour a bien été enregistré. 🎉', 'success');
                    mainForm.reset();
                    selectedProducts = [];
                    updateSelectedUI();
                    updateHiddenInput();
                    renderProducts(products);
                    // Re-enable submit button for another submission
                    if (submitBtn) submitBtn.disabled = false;
                })
                .catch(function(err) {
                    console.error(err);
                    var translations = window.fieldTestTranslations || {};
                    showFeedback(translations.error_generic || 'Une erreur est survenue. Veuillez réessayer.', 'error');
                    if (submitBtn) submitBtn.disabled = false;
                });
        });
    }

    function showFeedback(message, type) {
        if (!feedbackMsg) return;
        feedbackMsg.textContent = message;
        feedbackMsg.className = 'field-test-feedback ' + type;
        feedbackMsg.style.display = 'block';
    }
});
